<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :title="this.$t('CargoMsg.Cargo_ModifyWriteOffRecord')"
    width="400px"
  >
    <div class="app-main-inner-row">
      <el-form label-width="80px" label-position="left">
        <div class="el-form-item-wrapper">
          <!--我方银行-->
          <el-form-item :label="$t('WriteOff.ourSideBank')">
            <cargo-advance-select
              filterable
              no="1"
              :select-type="selectTypeNames.static_data_BankAccount"
              :cache="false"
              :default-value="ourBankAccountId"
              :static-options="ourBankAccountArray"
              options-width="450px"
              @parentCallBack="getOurBankAccountFromChild"
            />
          </el-form-item>
          <!--我方账号-->
          <el-form-item :label="$t('WriteOff.ourSideAccount')">
            <el-input v-model="ourBankAccountNo" readonly no="2" />
          </el-form-item>
          <el-form-item v-show="editType" no="3" :label="lbPayReceive + $t('WriteOff.method')">
            <cargo-advance-select
              filterable
              no="4"
              :clearable="false"
              :select-type="selectTypeNames.local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES"
              :cache="false"
              :default-value="receiveType||0"
              :static-options="receiveTypeArray"
              @parentCallBack="getReceiveTypesFromChild"
            />
          </el-form-item>
          <!--凭证号-->
          <el-form-item :label="$t('WriteOff.proofNo')||''">
            <el-input v-model="form.voucherNo" no="5" :maxlength="16" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CollectionPaymentDate')">
            <el-date-picker
              v-model="form.payReceiveDate"
              no="6"
              :clearable="false"
              :editable="false"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd"
            />
          </el-form-item>
          <!--销账备注-->
          <el-form-item :label="$t('WriteOff.writeOffRemarks')||''">
            <el-input v-model="form.remark" type="textarea" no="7" :maxlength="800" />
          </el-form-item>
          <!--票据号-->
          <el-form-item v-show="showTicketNo" :label="$t('Payment.ticketNo')||''">
            <el-input v-model="form.ticketNo" type="text" no="8" :maxlength="30" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" no="8" @click="commitHandler">{{ $t('common.btn.confirm') }}
      </el-button>
      <el-button no="9" @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getBankAccountList } from '@/api/bankAccount'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { AMOUNT_RECEIVE_TYPES } from '@/class/cargo/model/parameters/ClearingConstants'
import * as writeoffApi from '@/api/act/writeoff'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'

export default {
  name: 'EditWriteoffDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true },
    location: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      form: {
        type: null,
        ourBank: '',
        ourBankAccount: '',
        currency: ''
      },
      selectTypeNames: TYPE_NAMES,
      ourBankAccountArray: [],
      receiveTypeArray: [],
      ourBankAccountId: null,
      ourBankAccountNo: '',
      receiveType: null,
      editType: null,
      lbPayReceive: '',
      originalPayReceiveDate: null // 原始的收付日期
    }
  },
  computed: {
    showTicketNo() {
      // CARGO-45570 修改核销记录功能，如果付款方式是“支票”“银行承兑汇票”“商业承兑汇票”时，额外显示“票据号”填写栏位。非必填。
      return this.receiveType === ClearingConstants.RECEIVE_TYPE_CHECK.code ||
        this.receiveType === ClearingConstants.BANK_ACCEPTANCE_BILL.code ||
        this.receiveType === ClearingConstants.COMMERCIAL_ACCEPTANCE_BILL.code
    }
  },
  watch: {
    visible: {
      async handler(val) {
        this.innerVisible = val
        if (val) {
          // 数据初始化
          this.form = this.params.model
          if (this.form.ar) {
            this.lbPayReceive = this.$t('CargoMsg.Cargo_Receipt')
          } else {
            this.lbPayReceive = this.$t('CargoMsg.Cargo_Payment')
          }
          this.receiveType = this.form.type
          this.editType = this.params.editType
          // 初始化银行列表
          this.ourBankAccountArray = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
            return res.data
          })
          const ourBankAccount = this.ourBankAccountArray.find(param => {
            return param.accountNo === this.form.ourBankAccount && param.currency === this.form.ourBankCurrency
          })
          if (ourBankAccount) {
            this.ourBankAccountId = ourBankAccount.accountId
            this.ourBankAccountNo = ourBankAccount.accountNo
          }
          this.originalPayReceiveDate = this.form.payReceiveDate
        }
      },
      immediate: true
    },
    innerVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  async created() {
    // 初始化收付类型
    for (const value of AMOUNT_RECEIVE_TYPES.values()) {
      this.receiveTypeArray.push(value)
    }
  },
  methods: {
    getOurBankAccountFromChild(data) {
      this.ourBankAccountId = data.accountId
      this.ourBankAccountNo = data.accountNo
      this.form.ourBank = data.bankChineseName
      this.form.ourBankAccount = data.accountNo
      this.form.ourBankCurrency = data.currency
    },
    getReceiveTypesFromChild(data) {
      this.form.type = data.code
      this.receiveType = data.code
      if (this.receiveType === ClearingConstants.RECEIVE_TYPE_CASH.code || this.receiveType === ClearingConstants.RECEIVE_TYPE_VIRTUAL_CASH.code) { // 现金，虚拟现金
        this.ourBankAccountId = null
        this.ourBankAccountNo = ''
        this.form.ourBank = ''
        this.form.ourBankAccount = ''
        this.form.ourBankCurrency = ''
      } else {
        let bankAccount = this.getCurrencyBankAccount(this.form.currency, true)
        if (bankAccount === null) {
          bankAccount = this.getCurrencyBankAccount(this.form.currency, false)
        }
        if (bankAccount) {
          this.ourBankAccountId = bankAccount.accountId
          this.ourBankAccountNo = bankAccount.accountNo
          this.form.ourBank = bankAccount.bankChineseName
          this.form.ourBankCurrency = bankAccount.currency
          this.form.ourBankAccount = bankAccount.accountNo
        }
      }
    },
    commitHandler() {
      // CARGO-552 修改现金销账记录不选择我方银行无法保存 qm 19/12/2(当收款方式为现金、代收代付(0,4) 非必填)
      const receiveType = this.form.type
      if (!(receiveType >= 0)) {
        this.$message.warning(this.$t('WriteOff.selectMethodOfPayment'))
        return
      }
      const isBlankEmpty = receiveType !== ClearingConstants.RECEIVE_TYPE_CASH.code && receiveType !== ClearingConstants.RECEIVE_TYPE_VIRTUAL_CASH.code && receiveType !== ClearingConstants.RECEIVE_TYPE_AGENT.code
      if (!this.form.ourBank && isBlankEmpty) {
        this.$message.warning(this.$t('WriteOff.selectOurSideBank'))
        return
      }
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.form.branchId)
      this.form.rate = RateUtil.getForeignExchangeRateSafely(localCurrency, this.form.currency, !this.form.payReceiveDate ? new Date() : this.form.payReceiveDate, this.form.branchId)
      writeoffApi.updateActualAmount(this.form).then(res => {
        if (this.form.payReceiveDate !== this.originalPayReceiveDate) {
          this.modelSaveHandler()
        }
        this.$message.success(this.$t('CargoMsg.Cargo_EditedSuccessfully'))
        // 列表行回调，局部数据更新渲染
        this.$emit('successCallBack', this.form)
        this.closeHandler()
      }).catch(() => {
        this.$message.warning(this.$t('Clearing.FailedToModifyReconciliation'))
      })
      // this.modelSaveHandler()
    },
    modelSaveHandler() {
      if (this.form != null) {
        this.synchronizationChargeByPayReceiveDate(this.form.uuid, this.form.payReceiveDate)
        // ActualAmount.synchronizationChargeByPayReceiveDate(_model.key, _model.payReceiveDate, synchronizationSuccessHandler, faultHandler);
      }
    },
    // 同步费用上的收付日期
    synchronizationChargeByPayReceiveDate(actUuid, payReceiveDate) {
      writeoffApi.synchronizationChargeByPayReceiveDate({ actUuid, payReceiveDate, location: this.location, branchId: this.form.branchId }).catch(() => {
        this.faultHandler()
      })
    },
    closeHandler() {
      this.innerVisible = false
    },
    clearHandler() {
      this.form = {}
      this.form.ourBank = ''
      this.form.type = ''
      this.ourBankAccountId = null
      this.ourBankAccountNo = ''
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    // 获取默认账号
    getCurrencyBankAccount(currency, isDefault = false) {
      let ba = null
      for (const bankAccount of this.ourBankAccountArray) {
        if (currency === bankAccount.currency) {
          if (!isDefault) {
            ba = bankAccount
            break
          } else if (bankAccount.defaultPayment) {
            ba = bankAccount
            break
          }
        }
      }
      return ba
    }
  }
}
</script>

<style scoped>

</style>
